import {EstimateWithItemsRequest, Estimate, ItemizedEstimate, EstimateProjectCustomer, CreateItemizedEstimateRequest, EstimateTotal, EstimateToCustomerRequest } from './estimateType';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



class EstimateApi {

    static async sendEstimateToCustomer(estimateToCustomerRequest: EstimateToCustomerRequest) {
        try {
            const response = await fetch(`${API_BASE_URL}/estimates/send_estimate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(estimateToCustomerRequest), // Remove the extra object wrapper {payload}
                credentials: 'include', // Include cookies in the request
            });

            if (response.ok) {

            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                // Handle error response
                const errorBody = await response.text();
                let errorMessage = `Error ${response.status}: ${response.statusText}`;
                if (errorBody) {
                    errorMessage += ` - ${errorBody}`;
                }
                throw new Error(errorMessage);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to send estimate: ${error.message}`);
            } else {
                throw new Error('Failed to sebd estimate: An unknown error occurred.');
            }
        }
    }

    static async getEstimatesByCustomer(CustomerId: string, ProjectId: string) {
        //console.log('====id===', CustomerId)

        try {
            const response = await fetch(`${API_BASE_URL}/estimates/get_estimates_by_customer?customer_id=${CustomerId}${ProjectId ? `&project_id=${ProjectId}` : ''
                }`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {
                return responseBody;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return [];
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);

                //throw new Error(response.statusText || `Error: Status ${response.status}`);
                throw new Error(`${responseBody.error} status ${response.status}`);
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get estimate: ${error.message}`);
            } else {
                throw new Error('Failed to get estimate: An unknown error occurred.');
            }
        }
    }

    static async getEstimatesProjectsCustomers() {
        try {
            const response = await fetch(`${API_BASE_URL}/estimates/estimates_projects_customers`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {

                const estimates: EstimateProjectCustomer[] = responseBody.data.map((item: any) => {
                    return {
                        estimate_id: item.attributes.estimate_id,
                        name: item.attributes.name,
                        description: item.attributes.description,
                        terms_and_conditions: item.attributes.terms_and_conditions,
                        total_dollar: item.attributes.total_dollar,
                        //total_hour: item.attributes.total_hour,
                        non_optional_dollar: item.attributes.non_optional_dollar,
                        optional_dollar: item.attributes.optional_dollar,
                        //non_optional_hour: item.attributes.non_optional_hour,
                        //optional_hour: item.attributes.optional_hour,
                        time_to_complete_day: item.attributes.time_to_complete_day,
                        time_to_complete_hr: item.attributes.time_to_complete_hr,

                        tax_rate: item.attributes.tax_rate,
                        discount_usd: item.attributes.discount_usd,
                        tax_amount: item.attributes.tax_amount,
                        final_total: item.attributes.final_total,

                        project_id: item.attributes.project_id,
                        project_name: item.attributes.project_name,
                        project_description: item.attributes.project_description,
                        project_type: item.attributes.project_type,
                        customer_id: item.attributes.customer_id,
                        customer_first_name: item.attributes.customer_first_name,
                        customer_last_name: item.attributes.customer_last_name,
                        customer_address_1: item.attributes.customer_address_1,
                        customer_city: item.attributes.customer_city,
                        customer_state: item.attributes.customer_state,
                        customer_zip: item.attributes.customer_zip,
                        customer_phone: item.attributes.customer_phone,
                        customer_email: item.attributes.customer_email,
                    };
                });

                return estimates;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Session expired. Try to refresh your browser.`);
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return [];
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);
                if (response.status === 401) {
                    //throw new Error(response.statusText || `Error: Status ${response.status}`);
                    throw new Error(`${responseBody.error} status ${response.status}: Session expired. Try to refresh your browser.`);
                }
                else {
                    throw new Error(`${responseBody.error} status ${response.status}`);
                }
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get estimate-project: ${error.message}`);
            } else {
                throw new Error('Failed to get estimate-project: An unknown error occurred.');
            }
        }
    }

static async createEstimate(EstimateWithItemsRequest: EstimateWithItemsRequest) {
    try {
        const response = await fetch(`${API_BASE_URL}/estimates`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(EstimateWithItemsRequest),
            credentials: 'include', // Include cookies in the request
        });
        
        const responseBody = await response.json();
        
        if (response.status === 201) {
            return responseBody;
        }
        else if (response.status === 401) {
            throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
        }
        else {
            if (responseBody.error.includes('duplicate')) {
                throw new Error(`Duplicated data entries status ${response.status}`);
            }
            else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(`Failed to create estimate: ${error.message}`);
        } else {
            throw new Error('Failed to create estimate: An unknown error occurred.');
        }
    }
}

    static async createItemizedEstimate(itemizedEstimate: CreateItemizedEstimateRequest[]) {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_estimates`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ itemized_estimate: { itemizedEstimate } }),

                credentials: 'include',
            });
            const responseBody = await response.json();
            if (response.status === 201) {
                return responseBody;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (responseBody.error.includes('duplicate')) {
                    // This checks if the word "duplicate" appears in the error message
                    //throw new Error('Duplicated data entries' || `Error: Status ${response.status}`);
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else {
                    throw new Error(response.statusText);
                }
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to create itemized estimate: ${error.message}`);
            } else {
                throw new Error('Failed to create itemized estimate: An unknown error occurred.');
            }
        }
    }

    //static async updateItemizedEstimate(itemizeEstimateId: string, itemized_estimate: ItemizedEstimate) {
    static async updateItemizedEstimate(itemizeEstimateId: string, itemized_estimate: ItemizedEstimate) {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_estimates/${itemizeEstimateId}`, {
                method: 'PATCH',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ itemizedEstimate: itemized_estimate }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);

                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update itemized estimate: ${error.message}`);
            } else {
                throw new Error('Failed to update itemized estimate: An unknown error occurred.');
            }
        }
    }


    static async getItemizedEstimates(id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_estimates/by_estimate?estimate_id=${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();
            //console.log('=====response======', responseBody)
            if (response.status === 200) {
                const itemizedEstimates: ItemizedEstimate[] = responseBody.data.data.map((item: any) => {
                    return {
                        itemized_estimate_id: item.attributes.itemized_estimate_id,
                        estimate_id: item.attributes.estimate_id,
                        code: item.attributes.code,
                        description: item.attributes.description,
                        unit_price_dollar: item.attributes.unit_price_dollar,
                        quantity: item.attributes.quantity,
                        sub_total_dollar: item.attributes.sub_total_dollar,
                        cost_type: item.attributes.cost_type,
                        duration_hour: item.attributes.duration_hour,
                        is_optional: item.attributes.is_optional,
                    };
                });

                const totals: EstimateTotal = {
                    total_dollar: Number(responseBody.totals.total_dollar),
                    total_hour: Number(responseBody.totals.total_hour),
                    non_optional_dollar: Number(responseBody.totals.non_optional_dollar),
                    non_optional_hour: Number(responseBody.totals.non_optional_hour),
                    optional_dollar: Number(responseBody.totals.optional_dollar),
                    optional_hour: Number(responseBody.totals.optional_hour),
                    tax_rate: Number(responseBody.totals.tax_rate),
                    tax_amount: Number(responseBody.totals.tax_amount),
                    discount_usd: Number(responseBody.totals.discount_usd),
                    final_total: Number(responseBody.totals.final_total)

                };

                return { itemizedEstimates, totals };
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return {
                    itemizedEstimates: [],
                    totals: {
                        total_dollar: 0,
                        total_hour: 0,
                        non_optional_dollar: 0,
                        non_optional_hour: 0,
                        optional_dollar: 0,
                        optional_hour: 0
                    }
                };
            }
            else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get itemized estimate: ${error.message}`);
            } else {
                throw new Error('Failed to get itemized estimate: An unknown error occurred.');
            }
        }
    }


    static async viewEstimatePdf(id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/estimates/pdf?estimate_id=${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });


            if (response.ok) {
                // Return the PDF blob directly
                const blob = await response.blob();
                return blob;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (response.status === 401) {
                    //throw new Error(response.statusText || `Error: Status ${response.status}`);
                    throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
                }
                else {
                    throw new Error(`${response.statusText} status ${response.status}`);
                }
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to view estimate pdf: ${error.message}`);
            } else {
                throw new Error('Failed to view estimate pdf: An unknown error occurred.');
            }
        }
    }


    static async getEstimate(id: string): Promise<{
        estimate: Estimate;
        itemizedEstimates: ItemizedEstimate[];
        totals: EstimateTotal;
    }> {
        try {
            const response = await fetch(`${API_BASE_URL}/estimates/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                // Parse estimate data
                const estimateData = responseBody.estimate.data.attributes;
                const estimate: Estimate = {
                    estimate_id: estimateData.estimate_id,
                    name: estimateData.name,
                    description: estimateData.description,
                    time_to_complete_hr: estimateData.time_to_complete_hr,
                    time_to_complete_day: estimateData.time_to_complete_day,
                    tax_rate: estimateData.tax_rate,
                    discount_usd: estimateData.discount_usd,
                    terms_and_conditions: estimateData.terms_and_conditions,
                    project_id: estimateData.project_id,
                    customer_id: estimateData.customer_id
                };

                // Parse line items data
                const itemizedEstimates: ItemizedEstimate[] = responseBody.line_items.data.map((item: any) => {
                    return {
                        itemized_estimate_id: item.attributes.itemized_estimate_id,
                        estimate_id: item.attributes.estimate_id,
                        code: item.attributes.code,
                        description: item.attributes.description,
                        unit_price_dollar: parseFloat(item.attributes.unit_price_dollar),
                        quantity: parseFloat(item.attributes.quantity),
                        sub_total_dollar: parseFloat(item.attributes.sub_total_dollar),
                        cost_type: item.attributes.cost_type,
                        duration_hour: parseFloat(item.attributes.duration_hour),
                        is_optional: item.attributes.is_optional,
                    };
                });

                // Parse totals data
                const totals: EstimateTotal = {
                    total_dollar: parseFloat(responseBody.totals.total_dollar),
                    total_hour: parseFloat(responseBody.totals.total_hour),
                    non_optional_dollar: parseFloat(responseBody.totals.non_optional_dollar),
                    non_optional_hour: parseFloat(responseBody.totals.non_optional_hour),
                    optional_dollar: parseFloat(responseBody.totals.optional_dollar),
                    optional_hour: parseFloat(responseBody.totals.optional_hour),
                    tax_rate: responseBody.totals.tax_rate,
                    tax_amount: responseBody.totals.tax_amount,
                    discount_usd: responseBody.totals.discount_usd,
                    final_total: responseBody.totals.final_total
                };

                return { estimate, itemizedEstimates, totals };
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else if (response.status === 404) {
                throw new Error('Estimate not found');
            } else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get estimate: ${error.message}`);
            } else {
                throw new Error('Failed to get estimate: An unknown error occurred.');
            }
        }
    }


    static async updateEstimate(estimateId: string, estimate: Estimate) {
        try {
            const response = await fetch(`${API_BASE_URL}/estimates/${estimateId}`, {
                method: 'PATCH',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ estimate: estimate }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);

                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update estimate: ${error.message}`);
            } else {
                throw new Error('Failed to update estimate: An unknown error occurred.');
            }
        }
    }

    static async updateEstimateWithLineItems(estimateId: string, estimate: Partial<Estimate>, itemizedEstimates: ItemizedEstimate[]) {
        try {
            // Transform itemized estimates to match backend format
            const lineItems = itemizedEstimates.map(item => {
                const lineItem: any = {
                    code: item.code,
                    description: item.description,
                    quantity: item.quantity,
                    unit_price_dollar: item.unit_price_dollar,
                    sub_total_dollar: item.sub_total_dollar,
                    cost_type: item.cost_type,
                    duration_hour: item.duration_hour,
                    is_optional: item.is_optional
                };

                // Only include 'id' field if item already exists (has itemized_estimate_id)
                if (item.itemized_estimate_id && item.itemized_estimate_id !== '') {
                    lineItem.id = item.itemized_estimate_id;
                }
                // For new items, omit the 'id' field entirely

                return lineItem;
            });

            const response = await fetch(`${API_BASE_URL}/estimates/${estimateId}/update_with_lineitems`, {
                method: 'PATCH',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    estimate: estimate,
                    lineItems: lineItems
                }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                return responseBody;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update estimate with line items: ${error.message}`);
            } else {
                throw new Error('Failed to update estimate with line items: An unknown error occurred.');
            }
        }
    }

    static async deleteEstimate(estimate_id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/estimates/${estimate_id}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete estimate: ${error.message}`);
            } else {
                throw new Error('Failed to delete estimate: An unknown error occurred.');
            }
        }
    }

    static async deleteAllItemizedEstimate(estimate_id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_estimates/estimates/${estimate_id}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete itemized estimate: ${error.message}`);
            } else {
                throw new Error('Failed to delete itemized estimate: An unknown error occurred.');
            }
        }
    }


    static async deleteItemizedEstimate(itemizedEstimate_id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_estimates/${itemizedEstimate_id}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete itemized estimate: ${error.message}`);
            } else {
                throw new Error('Failed to delete itemized estimate: An unknown error occurred.');
            }
        }
    }
}

export default EstimateApi;